export class Shunt {
  public brand: string = '';
  public model: string = '';
  public adjustment: number | null = null;
  public antiSyphon: boolean = false;
  public type: string = '';
}
